import { render } from "./IframTem.vue?vue&type=template&id=946e5eee"
import script from "./IframTem.vue?vue&type=script&lang=js"
export * from "./IframTem.vue?vue&type=script&lang=js"
script.render = render

export default script